const USD_PER_AI_CREDIT = 0.01;
const TOKENS_PER_AI_CREDIT_BY_FEATURE = {
  signals: 14700,
  // ~$0.0075
  research_agent: 7600,
  // ~$1.25
  scheduled_agents: 1650,
  // ~$2.50
  mcp_tool_call: 1e4
  // ~$0.01
};
function tokensToAiCredits(totalTokens, featureKey) {
  return totalTokens / TOKENS_PER_AI_CREDIT_BY_FEATURE[featureKey];
}
const AiUsageOperationKeyPrefix = {
  Signals: "signals:",
  ResearchAgentTurn: "research_agent:turn:",
  ResearchAgentGradingFinding: "research_agent:grading_finding:",
  ResearchAgentTeammateFinding: "research_agent:teammate_finding:",
  ScheduledAgentsOrchestration: "scheduled_agents:orchestration:",
  ScheduledAgentsSubagent: "scheduled_agents:subagent:",
  McpToolCall: "mcp_tool_call:"
};
function buildAiUsageOperationKey(prefix, ...operationIds) {
  return `${prefix}${operationIds.join(":")}`;
}
export {
  AiUsageOperationKeyPrefix,
  TOKENS_PER_AI_CREDIT_BY_FEATURE,
  USD_PER_AI_CREDIT,
  buildAiUsageOperationKey,
  tokensToAiCredits
};
//# sourceMappingURL=aiCredits.js.map
